/*jslint browser: true, esversion: 5 */
/*global window, $, jQuery, _ */

/**
 * Turns a select-box into an easy to use multiple select-box
 */

STUDIP.MultiSelect = {
    create: function (id, itemName, options) {
        options = options || {};
        var count = $(id).find('option:selected').length;
        var count_template = _.template('<%= count %> ausgewählt'.toLocaleString());
        var update_counter = function () {
            var count = $(id).find('option:selected').length;
            $(id).next().find('.counter').text(count_template({count: count}));
        };

        if (!$(id).attr('multiple')) {
            $(id).attr('multiple', 'multiple').css('height', '6em');
        }
        $(id).multiSelect({
            selectableHeader:
                '<div class="header">' +
                '  <a href="#" class="button select-all">' + 'Alle hinzufügen'.toLocaleString() + '</a>' +
                '</div>',
            selectionHeader:
                '<div class="header">' +
                '  <div class="counter">' + count_template({count: count}) + '.</div>' +
                '  <a href="#" class="button deselect-all">' + 'Alle entfernen'.toLocaleString() + '</a>' +
                '</div>',
            keepOrder: true,
            cssClass: ['studip-multi-select', options.cssClass || ''].join(' ').trim(),
            afterInit: function () {
                $(id).next().find('.ms-elem-selectable,.ms-elem-selection').find('br').remove();
            },
            afterSelect: update_counter,
            afterDeselect: update_counter
        });

        $(id).next().find('.select-all').click(function () {
            $(id).multiSelect('select_all');
        });
        $(id).next().find('.deselect-all').click(function () {
            $(id).multiSelect('deselect_all');
        });
    }
};

jQuery(function () {
    jQuery.extend(jQuery.ui.multiselect, {
        locale: {
            addAll: "Alle hinzufügen".toLocaleString(),
            removeAll: "Alle entfernen".toLocaleString(),
            itemsCount: "ausgewählt".toLocaleString()
        }
    });
});
